import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import "./TopBar.scss";
import '@aws-amplify/ui-react/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faShieldAlt, faHome } from '@fortawesome/free-solid-svg-icons'; // Import admin icon
import { fetchAuthSession, fetchUserAttributes } from "aws-amplify/auth";

const TopBar = ({ onSignOut }) => {
  const navigate = useNavigate();
  const [userAttributes, setUserAttributes] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  const location = useLocation();
  const isOnAdminPage = location.pathname.startsWith('/admin');

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        // Fetch session tokens
        const [session, attributes] = await Promise.all([
          fetchAuthSession(),
          fetchUserAttributes()
        ]);
        // Extract groups from ID token
        const groups = session.tokens.idToken?.payload["cognito:groups"] || [];
        setIsAdmin(groups.includes("administrator"));
        setUserAttributes(attributes);
      } catch (error) {
        console.error("Error fetching user session:", error);
      }
    };

    fetchUserDetails();
  }, []);


  const displayName = userAttributes && Object.keys(userAttributes).length > 0
    ? userAttributes['custom:display_name'] || 'guest'
    : 'guest';

  const handleMainClick = () => {
    navigate('/login');
  };

  // Navigate to the Admin page
  const handleAdminClick = () => {
    navigate('/admin');
  };


  return (
    <div className="topbarContainer">
      <div className="logoContainer">
        <img src="/logo.png" alt="Samlex logo" className="logo" onClick={handleMainClick} />
      </div>

      <div className='userContainer'>
        {/* <img src="./Ted.jpg" alt="" className="user" /> */}
        <span className="username">
          {displayName}
          {isAdmin && <FontAwesomeIcon icon={faKey} className="adminIcon" />} {/* Show admin icon if user is admin */}
        </span>

        {/* Show Admin button only if the user is an admin */}
        {isAdmin && (
          <button
            onClick={() => {
              if (isOnAdminPage) {
                navigate('/product');  // Go to product page
              } else {
                navigate('/admin');    // Go to admin page
              }
            }}
            className="adminButton"
          >
            {isOnAdminPage ? 
              <FontAwesomeIcon icon={faHome} style={{ marginRight: '5px' }} /> : 
              <FontAwesomeIcon icon={faShieldAlt} style={{ marginRight: '5px' }} />
            }
            {isOnAdminPage ? 'Product' : 'Admin'}
          </button>
        )}

        {onSignOut && (
          <button onClick={onSignOut} className="signOutButton">
            Sign Out
          </button>
        )}
      </div>
    </div>
  );
};

export default TopBar;
